import moment from "moment-jalaali"

export const WeekStartEnd = (firstDay, mode) => {
    if (mode === 'next') {
        return (
            {
                dateTimeFrom: moment(new Date(firstDay.Year, firstDay.Month, firstDay.Day, 0, 0, 0)).toISOString(),
                dateTimeTo: moment(new Date(firstDay.Year, firstDay.Month, firstDay.Day + 7, 0, 0, 0)).toISOString()
            }
        )
    } else if (mode === 'previous') {
        return (
            {
                dateTimeFrom: moment(new Date(firstDay.Year, firstDay.Month, firstDay.Day, 0, 0, 0)).toISOString(),
                dateTimeTo: moment(new Date(firstDay.Year, firstDay.Month, firstDay.Day + 7, 0, 0, 0)).toISOString()
            }
        )
    } else {
        return null
    }
}